import api from './api';

const NOTIFICATIONS_ENDPOINT = '/api/notifications';

export const getNotifications = async () => {
  const response = await api.get(NOTIFICATIONS_ENDPOINT);
  return response.data || [];
};

export const getUnreadNotificationCount = async () => {
  const response = await api.get(`${NOTIFICATIONS_ENDPOINT}/unread-count`);
  return response.data?.count || 0;
};

export const markNotificationRead = async (notificationId) => {
  const response = await api.patch(`${NOTIFICATIONS_ENDPOINT}/${notificationId}/read`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
  await api.patch(`${NOTIFICATIONS_ENDPOINT}/read-all`);
};

export const savePushSubscription = async ({ endpoint, p256dh, auth }) => {
  await api.post(`${NOTIFICATIONS_ENDPOINT}/push-subscriptions`, { endpoint, p256dh, auth });
};
